import React from 'react'
import './styles.scss'
import CandidatesRows from 'components/embeds/stadtrat/candidatesRows'
import { Header } from 'components/header'
import { CheckedIcon } from 'components/icons/checkedIcon'

export class CandidatesList extends React.Component {
  constructor(props) {
    super(props)
    this.intervalId = setInterval(() => {
      this.refresh()
    }, 30000)
    this.state = {
      round: 1,
      showAllCandidates: false,
      data: null
    }
  }

  componentDidMount() {
    this.refresh().then(data => {
      this.setState({
        round:
          data[0].allCandidates.reduce(
            (a, b) => a + (+b['votes round 2'] || 0),
            0
          ) > 0 && data[0].secondRoundEnabled
            ? 2
            : 1
      })
    })
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  get listLength() {
    let length = 0
    const election = this.state.data[0]
    if (election) {
      const currentRound = election.rounds[this.state.round]
      const previousRound = election.rounds[this.state.round - 1]
      const candidatesCurrentRound = [
        ...currentRound.candidatesElected,
        ...currentRound.candidatesNotElected
      ]
      if (previousRound) {
        length =
          previousRound.candidatesElected.length + candidatesCurrentRound.length
      } else {
        length = candidatesCurrentRound.length
      }
    }
    return length
  }

  // elected of round 1 + round 2
  get electedSoFar() {
    const election = this.state.data[0]
    if (election) {
      return election.rounds[this.state.round - 1]
        ? election.rounds[this.state.round].candidatesElected.concat(
            election.rounds[this.state.round - 1].candidatesElected
          )
        : election.rounds[this.state.round].candidatesElected
    }
    return []
  }

  refresh() {
    return window
      .fetch(
        'https://storage.googleapis.com/wch-interactive/presidentielle-fr-2022/' +
          this.props.electionId +
          '.json?' +
          Math.random()
      )
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState({
          data: data
        })
        return data
      })
  }

  render() {
    const limit =
      new URLSearchParams(window.location.hash.split('?')[1]).get('limit') || 3
    const DATA = this.state.data ? this.state.data[0] : null
    let electionStateMsg = <div>Lädt...</div>
    let electionState = 0
    let hasTwoRounds = false

    if (DATA) {
      hasTwoRounds = DATA.secondRoundEnabled

      if (
        DATA.allCandidates.reduce(
          (a, b) => a + (+b['votes round ' + this.state.round] || 0),
          0
        ) > 0 &&
        DATA['doneRound' + this.state.round] === false // &&
        // !(hasTwoRounds && this.state.round === 1)
      ) {
        electionState = 1

        electionStateMsg = (
          <>
            {DATA.status && (
              <>
                {DATA.status}
                <br />
              </>
            )}

            {DATA.countStatus}
          </>
        )
      } else if (
        DATA['doneRound' + this.state.round] === true ||
        (hasTwoRounds && this.state.round === 1)
      ) {
        electionState = 2
        electionStateMsg = (
          <>
            Résultat final <CheckedIcon />
          </>
        )
      } else {
        electionState = 0
        electionStateMsg = <>Il n'y a pas encore de résultats</>
      }
    }

    return (
      <>
        {!DATA ? (
          <div className='loading-container'>
            <div className='ui active dimmer'>
              <div className='ui loader' />
            </div>
          </div>
        ) : (
          <div>
            {(DATA.title || DATA.subtitle) && (
              <Header title={DATA.title} description={DATA.subtitle} />
            )}

            <div className='round'>
              {hasTwoRounds && (
                <div
                  className={
                    (this.state.round === 2 ? 'active' : '') + ' round-button'
                  }
                  onClick={() => {
                    this.setState({ round: 2 })
                  }}
                >
                  2e tour
                </div>
              )}
              <div
                className={
                  (this.state.round === 1 ? 'active' : '') + ' round-button'
                }
                onClick={() => {
                  this.setState({ round: 1 })
                }}
              >
                1er tour
              </div>
              <div style={{ flexGrow: 1 }} />
            </div>

            <div className='election-state'>{electionStateMsg}</div>

            <div className='candidates-wrapper'>
              {this.electedSoFar.length > 0 && (
                <div className='elected candidates-bloc'>
                  <div className='list-label-top'>
                    <small>
                      {DATA['doneRound' + this.state.round] === false
                        ? 'Élu'
                        : 'Élu'}
                    </small>
                    <small>% des suffrages exprimés</small>
                  </div>

                  <CandidatesRows
                    absMajority={+DATA['clearMajorityRound' + this.state.round]}
                    validVotes={+DATA['validVotesRound' + this.state.round]}
                    round={this.state.round}
                    candidates={this.electedSoFar}
                    limit={this.state.showAllCandidates ? false : limit}
                    showClearMajorityLabel
                  />
                </div>
              )}
              {electionState !== 0 &&
                (this.state.showAllCandidates ||
                  limit > this.electedSoFar.length) && (
                  <div className='non-elected candidates-bloc'>
                    <div className='list-label-top'>
                      <small>
                         
                        {DATA['doneRound' + this.state.round] === false
                          ? 'Actuellement non élus'
                          : this.state.round === 1 ? ' Non élus' : ' Non élue'}
                      </small>
                      <small>% des suffrages exprimés</small>
                    </div>

                    <CandidatesRows
                      absMajority={
                        +DATA['clearMajorityRound' + this.state.round]
                      }
                      validVotes={+DATA['validVotesRound' + this.state.round]}
                      round={this.state.round}
                      candidates={
                        DATA.rounds[this.state.round].candidatesNotElected
                      }
                      showClearMajorityLabel={
                        this.electedSoFar.length <= 0 ||
                        DATA.rounds[this.state.round].candidatesElected
                          .length <= 0
                      }
                      limit={
                        this.state.showAllCandidates
                          ? false
                          : limit - Math.max(limit, this.listLength)
                      }
                    />
                  </div>
                )}
            </div>
            {this.listLength > limit && (
              <div
                className='more-candidates-trigger'
                onClick={() => {
                  this.setState(state => ({
                    showAllCandidates: !state.showAllCandidates
                  }))
                }}
              >
                {this.state.showAllCandidates ? (
                  <div>
                    <i className='ui icon chevron up' />↑ Montrer moins
                  </div>
                ) : (
                  <div>
                    <i className='ui icon chevron down' />↓ Montrer davantage
                  </div>
                )}
              </div>
            )}

            {/* {this.state.data[0].related_stories.length > 0 && (
              <div className='related-stories'>
                <div>
                  <b>Articles en relation</b>
                </div>
                <ArticleTeasers
                  sorting='reverse chronologically by creation date'
                  numberOfCards='three'
                  articleIds={this.state.data[0].related_stories}
                />
              </div>
            )} */}
          </div>
        )}
      </>
    )
  }
}

export default CandidatesList
